import { Button, Dialog, DialogContent, Stack, Typography } from '@mui/material';
import Avatar from 'components/@extended/Avatar';
import { PopupTransition } from 'components/@extended/Transitions';
import { DollarCircle } from 'iconsax-react';

interface Props {
  open: boolean;
  handleClose: () => void;
}

export default function UserNotActiveAlert({ open, handleClose }: Props) {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      keepMounted
      fullWidth
      TransitionComponent={PopupTransition}
      maxWidth="xs"
      aria-labelledby="user-not-active-title"
      aria-describedby="user-not-active-description"
    >
      <DialogContent sx={{ mt: 2, my: 1 }}>
        <Stack alignItems="center" spacing={3.5}>
          <Avatar color="error" sx={{ width: 72, height: 72, fontSize: '1.75rem' }}>
            <DollarCircle variant="Bold" />
          </Avatar>
          <Stack spacing={2}>
            <Typography variant="h4" align="center">
              No Active Users
            </Typography>
            <Typography align="center">{'You cannot place an order because no users are currently active!'}</Typography>
          </Stack>
          <Button fullWidth onClick={handleClose} color="primary" variant="contained" autoFocus>
            Close
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
